'use client';
import {
  PlaceholderConfig,
  PlaceholderContextValues
} from '@spa/lib/react/context/PlaceholderContext';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../../placeholder/placeholder.component';
import { Props } from './checkout-cart.component';
import dynamic from 'next/dynamic';

const DynamicCheckoutCartComponent: ComponentType<Props> = dynamic(
  () => import('./checkout-cart.component')
);

export default DynamicCheckoutCartComponent;

export function calculateCheckoutCartPlaceholderConfig(
  _: Props,
  contextValues: PlaceholderContextValues
): PlaceholderConfig {
  const cart = contextValues.cart;
  let heightSinceWidth: HeightSinceWidth;
  if (cart === null || cart.entries.length === 0) {
    heightSinceWidth = [
      { sinceWidth: 0, height: 282 },
      { sinceWidth: 466, height: 244 },
      { sinceWidth: 571, height: 214 },
      { sinceWidth: 768, height: 253 }
    ];
  } else {
    heightSinceWidth = [
      { sinceWidth: 0, height: 835 },
      { sinceWidth: 425, height: 763 },
      { sinceWidth: 434, height: 729 },
      { sinceWidth: 580, height: 712 },
      { sinceWidth: 768, height: 814 },
      { sinceWidth: 1024, height: 603 },
      { sinceWidth: 1442, height: 586 }
    ];
  }

  return {
    heightSinceWidth
  };
}
